import './App.css';
import './styles/Home.css';
import './styles/Header.css';
import './styles/Footer.css';
import './media/Headermedia.css';
import './media/Homemedia.css';
import Footer from './Component/Footer';
import Home from './Component/Home';
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from 'react';
import Cursorpointer from './Component/Cursorpointer';
// import CanvasBackground from './Component/CanvasBackground';

function App() {
  useEffect(()=>{
    AOS.init({
        
      });
},[])

 // text for animated text in Heading
 const [isMobile, setIsMobile] = useState(false);

 //remove animated cursor in mobile view
 useEffect(() => {
     // Function to check screen width
     const handleResize = () => {
         setIsMobile(window.innerWidth <= 650);
     };

     // Initial check
     handleResize();

     // Event listener for window resize
     window.addEventListener('resize', handleResize);

     // Cleanup the event listener
     return () => {
         window.removeEventListener('resize', handleResize);
     };
 }, []);
  return (
    <div className="App">
      {/* <CanvasBackground /> */}
        {
          !isMobile && ( <Cursorpointer />)
        }
        <Home />
        <Footer />
    </div>
  );
}

export default App;
